export default __webpack_public_path__ + "static/media/bajajAllianz.525b1b07.svg";